<!-- 
 <div class="container-fluid" style="height:100%;">
 
    <div class="row">
          <div class="col-md-12">
              <app-app-menu></app-app-menu>
          </div>
    </div>
 

    <div class="row" style="height:95%;">
    
        <div class="col-md-3" style="height:100%;  padding-right: 3px;">
          <app-layers-tree></app-layers-tree>
        </div>
        
        <div class="col-md-9" style="height:100%;  padding-left: 3px;">
        
            <div style="height:70%;">
                  <app-ol-map></app-ol-map>
              </div>
              
              <app-feature-info></app-feature-info>
              
              <div style="height:30%">
                  <app-table></app-table>
              </div>

        </div>
    </div>
 
 </div>
 -->
<!-- 
<div style="height: 100%; overflow: hidden;">
 <horizontal-split-pane
    primary-component-minsize="10"
    secondary-component-minsize="80"
    primary-component-initialratio="1">
     
     <div class="split-pane-content-primary">
     
         <app-ol-map></app-ol-map>
         <app-feature-info></app-feature-info>
         <div  style="z-index: 1; position: absolute; top:50px; left:10px" (click)="showMenu()" >Meni</div>
         <div *ngIf="(treeVisible)" style="height:70%; width:250px; padding-right: 3px; z-index: 1; position: absolute; top:50px; left: 50px">
               <app-layers-tree></app-layers-tree>
         </div>
         
     </div>
     <div class="split-pane-content-secondary" style="z-index: 9999;  width: 100% ;position: relative">
          <div style="background :red; z-index: 9999; height:800px;  width: 100% ; position: relative">        
           <app-table></app-table>
         </div>
     </div>
 
 </horizontal-split-pane>
 </div>
  -->
<div class="shell">
  <div class="pageHeader">
    <p-toast key="mapView"></p-toast>

    <!-- LEFT -->
    <div class="leftArea">
      <a class="logoLink" routerLink="/" aria-label="Home">
        <img class="logo" alt="EAS" src="/assets/img/EPA_logo.png" />
      </a>
    </div>

    <!-- CENTER (desktop only) -->
    <div class="centerArea">
      <div class="centerDesktop">
        <div class="searchGroup">
          <app-search></app-search>
          <app-app-menu></app-app-menu>
        </div>

        <div class="dogrplan">
          <app-do-planning></app-do-planning>
        </div>
      </div>
    </div>

    <!-- RIGHT -->
    <div class="rightArea">

      <!-- BURGER (mobile only) -->
      <button class="btn burgerBtn" type="button"
              (click)="openMobileMenu()"
              aria-label="Odpri meni">
        <i class="pi pi-bars"></i>
      </button>

      <button *ngIf="reportvisible" class="btn reportbtn" (click)="openReport()" [disabled]="isGeneratingReport">
        <i class="pi pi-file"></i><span>POROČILA</span>
      </button>

      <button class="btn wikibtn" (click)="openWikiReport()">
        <i class="pi pi-info-circle"></i><span>VIRI</span>
      </button>

      <button *ngIf="locinfsid != null" class="btn rinfobtn" (click)="openLokInfReport()">
        <i class="pi pi-send"></i><span>INFO</span>
      </button>

      <button class="btn logoff" type="button" (click)="op.toggle($event)">
        <img src="/assets/img/logout.png" /><span>&nbsp;</span>
      </button>

      <p-popover #op>
        <div class="userMenu">
          <div *ngIf="isSuperuser">
            <div class="userMenuItem" routerLink="/admin">
              <i class="pi pi-users"></i>
              <span>Uporabniki</span>
            </div>
          </div>

          <div class="userMenuItem danger" (click)="logoff()">
            <i class="pi pi-sign-out"></i>
            <span>Odjava</span>
          </div>
        </div>
      </p-popover>
    </div>
  </div>

  <!-- MOBILE POPUP -->
  <p-dialog
    [(visible)]="mobileMenuVisible"
    [modal]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [resizable]="false"
    [showHeader]="false"
    [style]="{width: '640px', maxWidth: '95vw'}"
    [contentStyle]="{overflow: 'visible'}"
  >
    <div class="mobileMenuContent">

      <!-- TOP ROW: search + X -->
      <div class="mobileTopRow">
        <div class="mobileSearch">
          <app-search></app-search>
        </div>

        <button type="button" class="mobileCloseBtn" (click)="mobileMenuVisible=false" aria-label="Zapri">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="mobileBlock">
        <app-app-menu></app-app-menu>
      </div>

      <div class="mobileBlock">
        <app-do-planning></app-do-planning>
      </div>

    </div>
  </p-dialog>

  <!-- content -->
  <main class="pageContent">
  <!-- OUTER: tree overlays map so resizing tree doesn't move map -->
  <div class="splitFill outerLayout" [style.--tree-width]="treehidden ? '0px' : treeWidthPx + 'px'">

    <!-- TREE: absolute overlay, never pushes the map -->
    <div class="treeOverlay" [style.width.px]="treeWidthPx" [hidden]="treehidden">
      <div class="treeWrap">
        <div class="treeScroll">
          <app-layers-tree></app-layers-tree>
        </div>

        <div class="closeBar" (click)="setHiddenTree(true)">
          <img src="/assets/img/leftArrow.png" />
        </div>
      </div>
      <div class="treeGutter" (mousedown)="startTreeResize($event)"></div>
    </div>

    <!-- MAIN AREA: always full width, tree is an overlay above it -->
    <div class="mainArea">
      <!-- INNER: MAP/TABLE + LEGEND -->
      <as-split
        class="splitFill"
        direction="horizontal"
        unit="%"
        [gutterSize]="4"
        (dragEnd)="onAnySplitChanged()"
      >
        <!-- MAP + TABLE -->
        <as-split-area
          class="splitFill"
          [size]="legendhidden ? 100 : 82"
          [minSize]="20"
        >
          <as-split
            class="splitFill"
            direction="vertical"
            unit="%"
            [gutterSize]="4"
            (dragEnd)="onAnySplitChanged()"
          >
            <!-- MAP -->
            <as-split-area
              class="splitFill"
              [size]="tableshidden ? 100 : 45"
              [minSize]="20"
            >
              <div class="mapWrap">
                <app-ol-map></app-ol-map>
                <app-feature-info></app-feature-info>
                <app-reports></app-reports>
                <app-graphview></app-graphview>

                <div
                  *ngIf="showTreeButton && treehidden"
                  class="openBarTree"
                  (click)="setHiddenTree(false)"
                >
                  <img src="/assets/img/rightArrow.png" />
                </div>

                <div
                  *ngIf="showLegendButton && legendhidden"
                  class="openBarLegend"
                  (click)="setHiddenLegend(false)"
                >
                  <img src="/assets/img/leftArrow.png" />
                </div>
              </div>
            </as-split-area>

            <!-- TABLE -->
            <as-split-area
              class="splitFill"
              [size]="tableshidden ? 0 : 55"
              [minSize]="10"
            >
              <div class="tableWrap" [style.paddingLeft.px]="treehidden ? 0 : treeWidthPx">
                <app-table></app-table>
              </div>
            </as-split-area>
          </as-split>
        </as-split-area>

        <!-- LEGEND -->
        <as-split-area
          class="splitFill"
          [size]="legendhidden ? 0 : 18"
          [minSize]="legendhidden ? 0 : 10"
        >
          <div class="legendWrap">
            <app-selected-layers-detail-view></app-selected-layers-detail-view>
          </div>
        </as-split-area>
      </as-split>
    </div>
  </div>
</main>


</div>